<template>
  <div class="about-system-box">
    <a href="./machine"><img class="about-system-img" src="./img/about_machine.png" alt="機械について"></a>
    <!--<a href="./system"><img class="about-system-img" src="./img/about_system.png" alt="システムについて"></a>-->
  </div>
  
</template>

<script>
export default {
  name: 'AboutSystem',
}
</script>

<style scoped>
  .about-system-box{
    background-color: var(--main-color);
    text-align: center;
    padding:20px;
  }

   /* PC表示 */
  @media screen and (min-width:821px){
    .about-system-img{
      width:60vw;
      margin:10px;
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .about-system-img{
      width: 98vw;
      margin: 10px auto;
    }

    .about-system-box{

      padding:20px 0;
    }
  }
</style>